import Tabs from "../../../../src/pages/edge/adobe-journey-optimizer/public-classes/tabs/push-tracking-status.md";
import * as React from 'react';
export default {
  Tabs,
  React
};